// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Ox-z","sponsoredTooltipWrapper":"Px-z","sponsoredTooltip":"Qx-z","newCard":"Rx-z"};